import { BottomButton } from 'components/site/modals/SidebarModalWrapper/BottomButton';
import { useZoomToMarker } from 'hooks/map/useZoomToMarker';
import { EColors } from 'libs/styles/styling';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const DetailFooter = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxView = useContext(CtxView);
    const { zoomToMarkers } = useZoomToMarker();
    const isWide = useIsWide();
    const analytics = useAnalytics();

    const connectedMarkers = ctxModal.detailModal?.detail?.connectedMarkers ?? [];

    const openNewStory = async (newIndex: number) => {
        const newStoryId = ctxModal.storyList.visibleStoryIds[newIndex];
        ctxModal.setStoryList({
            ...ctxModal.storyList,
            currentIndex: newIndex
        });

        ctxModal.setDetailModal({
            id: newStoryId,
            detail: ctxView.allDetails.find((e) => e.storyId === newStoryId),
            markerId: null
        });

        analytics.track('detail_nav_button.clicked', {
            action: 'detail.opened'
        });
    };

    function actionClose() {
        ctxModal.setDetailModal(null);
    }

    function actionPrevious() {
        const newIndex = ctxModal.storyList.currentIndex - 1;
        openNewStory(newIndex);
    }

    function actionNext() {
        const newIndex = ctxModal.storyList.currentIndex + 1;
        openNewStory(newIndex);
    }

    function showOnMap() {
        analytics.track('detail_nav_button.clicked', {
            action: 'zoom_to_marker'
        });

        zoomToMarkers(connectedMarkers);

        if (!isWide) {
            ctxModal.closeAll();
        }
    }

    const listIsSet = Boolean(ctxModal.storyList);

    const isFirst = ctxModal.storyList?.currentIndex === 0;
    const isLast =
        ctxModal.storyList?.visibleStoryIds.length - 1 === ctxModal.storyList?.currentIndex;

    return (
        <S_DetailFooter className={props.className}>
            {isFirst || !listIsSet ? (
                <S_BottomSpace />
            ) : (
                <S_BottomButton
                    iconName="arrow-left"
                    text={Localization.PREVIOUS}
                    onClick={actionPrevious}
                    darkText={isWide}
                />
            )}
            {connectedMarkers.length ? (
                <S_BottomButton
                    iconName="location-dot"
                    text={Localization.SHOW_ON_MAP}
                    onClick={showOnMap}
                    darkText={isWide}
                />
            ) : (
                <S_BottomSpace />
            )}
            <S_BottomButton
                iconName="xmark"
                text={Localization.CLOSE}
                onClick={actionClose}
                darkText={isWide}
            />
            {isLast || !listIsSet ? (
                <S_BottomSpace />
            ) : (
                <S_BottomButton
                    iconName="arrow-right"
                    text={Localization.NEXT}
                    onClick={actionNext}
                    darkText={isWide}
                />
            )}
        </S_DetailFooter>
    );
};

const S_DetailFooter = styled.div`
    height: 75px;
    width: 100%;
    border-top: 1px solid ${EColors.BLACK3};
    background: #282727;
    box-shadow: inset 0px 5px 10px rgba(29, 29, 29, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-shrink: 0;
    padding: 0 0 0px 0;
    @media only screen and (min-width: 1260px) {
        box-shadow: 0px -4px 10px rgb(0 0 0 / 5%);
        background: #fafafa;
        border-top: 0px;
    }
`;

const S_BottomButton = styled(BottomButton)`
    width: 25%;
    height: 100%;
`;

const S_BottomSpace = styled.div`
    width: 25%;
    height: 100%;
`;
